<!--
 * @Description:
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="comp-fh-add-edit" v-if="visible">
    <jw-drawer class="fh-add-edit-popup" :width="autoWidth" :header="false" :footer="false" :visible="visible">
      <!-- 新增、编辑form表单 -->
      <fh-form ref="fhFormRef" v-bind="editParams" @cb="close" @cbResult="cbResult" />
    </jw-drawer>
  </div>
</template>

<script setup>
import { provide, ref } from 'vue';
import FhForm from './components/fh-form/fh-form.vue';
import { useLayoutStore } from '@/store';
const useLayout = useLayoutStore();
const autoWidth = ref('75%');

const visible = ref(false);
const emits = defineEmits(['cb', 'cbResult']);
const editParams = ref({});

const open = (option) => {
  const { isHongChong } = option;
  // 红冲定制情况下，视图id直接使用传入的视图id
  const defaultActiveKey = isHongChong ? option.viewId : useLayout?.changeViewId?.[option.entity] || option.viewId;
  editParams.value = { ...option, viewId: defaultActiveKey } || {};
  visible.value = true;
  autoWidth.value = '75%';
};
const close = (params) => {
  emits('cb', params);
  visible.value = false;
};
const cbResult = (res) => {
  //如果是关联表格过来的直接吐出去数据
  if (editParams.value?.isAssociated) {
    // visible.value = false;
    emits('cbResult', res);
    return false;
  }
  const resolveRes = [];
  if (Array.isArray(res?.businessId)) {
    resolveRes.push(...res.businessId);
  }
  if (Array.isArray(editParams.value?.hasedIds)) {
    resolveRes.push(...editParams.value.hasedIds); // 增加任务项原有数据id
  }

  emits('cbResult', resolveRes);
};
const changeAutoWidth = (params) => {
  console.log(123, params);
  autoWidth.value = params ? '100%' : '75%';
};
provide('formMethod', {
  changeAutoWidth
});
const fhFormRef = ref();
const cancelLoading = () => {
  fhFormRef.value?.closeLoading?.();
};
defineExpose({ open, visible, cancelLoading });
</script>
<style scoped lang="less">
@import './fh-add-edit.less';
</style>
<style lang="less">
.fh-add-edit-popup {
  .arco-drawer-body {
    padding: 0;
    // background: var(--color-fill-2);
  }
}
</style>
